import { axios } from "../../../../Global";
import React, { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { HiArrowLongRight } from "react-icons/hi2";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import { Navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import { checkAccessFn } from "../../../../utils/checkAccess";
import { sortByName } from "../../../../utils/sortByName";

export default function QuotationForm({
  submitForm,
  submitFormLoading,
  loadedValues,
  editing,
  cancelForm,
}) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  const statusOptions = [
    { id: 1, name: "Draft" },
    { id: 2, name: "Pending" },
    { id: 3, name: "Approved" },
    { id: 4, name: "Rejected" },
  ];
  const [date, setDate] = useState({
    transformed: "",
    original: "",
  });
  const [rejectedDate, setRejectedDate] = useState({
    transformed: "",
    original: "",
  });
  const [status, setStatus] = useState();
  const [clientOptions, setClientOptions] = useState([]);
  const [quotationTypeOptions, setQuotationTypeOptions] = useState([]);
  const [client, setClient] = useState("");
  const [quotType, setQuotType] = useState("");
  const [hourType, setHourType] = useState("");
  const [companyOptions, setCompanyOptions] = useState([]);
  const [company, setCompany] = useState("");
  const [sectorOptions, setSectorOptions] = useState([]);
  const [sector, setSector] = useState("");
  const [sourceOptions, setSourceOptions] = useState([]);
  const [source, setSource] = useState("");
  const [name, setName] = useState(loadedValues?.name || "");
  const token = localStorage.getItem("token");
  const [rejectedReason, setRejectedReason] = useState("");
  const [disableSubmit, setDisableSubmit] = useState(false);

  useEffect(() => {
    if (loadedValues && typeof loadedValues === 'object') {
      setDisableSubmit(true);
      setName(loadedValues.name || "");
      setClient(loadedValues.client_id || "");
      setCompany(loadedValues.company_id || "");
      setSector(loadedValues.sector_id || "");
      setSource(loadedValues.source_id || "");
      setQuotType(loadedValues.quotation_type_id || "");
      setHourType(loadedValues?.hour_type || "");
      setStatus(loadedValues?.status || "");
      setRejectedReason(loadedValues?.rejected_reason || "");
      setDate((p) => ({
        ...p,
        original:
          loadedValues?.approved_date?.split("-").reverse().join("-") || "",
        transformed: loadedValues?.approved_date || "",
      }));
      setRejectedDate((p) => ({
        ...p,
        original:
          loadedValues?.rejected_date?.split("-").reverse().join("-") || "",
      }));
    } else {
      setDisableSubmit(false);
    }
  }, [
    loadedValues,
    clientOptions,
    quotationTypeOptions,
    companyOptions,
    sourceOptions,
    sectorOptions,
  ]);
  useEffect(() => {
    axios
      .get(`/dashboard/quotation-input-value`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setLoading(false);
        if (res.data?.data) {
          setClientOptions(sortByName(res.data.data.client));
          setCompanyOptions(sortByName(res.data.data.company));
          setSourceOptions(sortByName(res.data.data.source));
          setSectorOptions(sortByName(res.data.data.sector));
          setQuotationTypeOptions(sortByName(res.data.data.quotation_type));
        }
      })
      .catch((err) => {});
  }, []);
  const validationFormHandler = (event) => {
    event.preventDefault();
    if (loadedValues) {
      if (
        loadedValues.name !== name ||
        loadedValues.client_id !== client ||
        loadedValues.company_id !== company ||
        loadedValues.sector_id !== sector ||
        loadedValues.source_id !== source ||
        loadedValues.quotation_type_id !== quotType ||
        loadedValues?.status !== status ||
        loadedValues?.rejected_reason !== rejectedReason ||
        loadedValues?.approved_date !==
          date?.original?.split("-").reverse().join("-")
      ) {
        if (status != loadedValues?.status) {
          submitForm(
            event,
            client,
            company,
            sector,
            source,
            quotType,
            hourType,
            name,
            status,
            rejectedReason,
            date,
            rejectedDate,
            editing
          );
        } else {
          submitForm(
            event,
            client,
            company,
            sector,
            source,
            quotType,
            hourType,
            name,
            null,
            rejectedReason,
            date,
            rejectedDate,
            editing
          );
        }
      } else {
        dispatch(setAppError({ msg: "Update  details before submit" }));
      }
    } else {
      submitForm(
        event,
        client,
        company,
        sector,
        source,
        quotType,
        hourType,
        name,
        status,
        rejectedReason,
        date,
        rejectedDate,
        editing
      );
    }
  };

  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);
  const isCreateMode = location.pathname.endsWith("/quotation/create");
  const isEditMode = location.pathname.includes("/quotation/edit");

  useEffect(() => {
    if (editing) {
      dispatch(
        setBreadCrumb([
          { label: "QUOTATION", link: "/dashboard/quotation" },
          { label: "EDIT", link: "" },
        ])
      );
      const check = checkAccess("Quotation", "quotation-edit");
      if (!check) navigate("/dashboard/quotation");
    } else {
      const check = checkAccess("Quotation", "quotation-create");
      if (!check) navigate("/dashboard/quotation");
    }
  }, [location.pathname]);

  // useEffect(() => {
  //   if(isCreateMode){
  //     dispatch(setBreadCrumb([
  //       {label: 'QUOTATION', link: '/dashboard/quotation'},
  //       {label: 'CREATE', link: ''},
  //     ]))
  //   }else{
  //     dispatch(setBreadCrumb([{label:'QUOTATION',link:'/dashboard/quotation'}]))
  //   }
  // }, [location.pathname]);
  console.log("quotType///////////0",quotType)
  return (
    <div className="flex flex-col justify-center items-center bg-white dark:bg-dark rounded-md py-5">
      <h2 className="text-xl font-semibold">Quotation Form</h2>
      {!loading ? (
        <form
          method="POST"
          onSubmit={(event) => validationFormHandler(event)}
          className="w-full  flex flex-col items-center justify-center"
        >
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              ENTER NAME
            </label>
            <input
              type="text"
              name="name"
              id={`addOrEdit-name`}
              required
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              defaultValue={name}
              onChange={(e) => {
                const errorElem = document.getElementById(`quotation-name`);
                errorElem.style.display = "none";
                setName(e.target.value?.toUpperCase());
              }}
              placeholder="Enter a name"
            />
            <p
              id={`quotation-name`}
              className="hidden w-full h-5 bg-red/5 text-red text-xs"
            ></p>
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-`} className="text-xs ">
              Select Client
            </label>
            <select
              name="client"
              id={`addOrEdit-client`}
              required
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              value={client}
              onChange={(e) => {
                const errorElem =
                  document.getElementById(`quotation-client_id`);
                errorElem.style.display = "none";
                setClient(e.target.value);
              }}
            >
              {loadedValues?.client_id ? (
                <option value="" hidden disabled>
                  Select a client
                </option>
              ) : (
                <option value="" hidden disabled>
                  Select a client
                </option>
              )}
              {clientOptions.map((cl) => (
                <option key={cl.id} value={cl.id} id={`client-${cl.id}`}>
                  {cl.name}
                </option>
              ))}
            </select>
            <p
              id={`quotation-client_id`}
              className="hidden w-full h-5 bg-red/5 text-red text-xs"
            ></p>
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-`} className="text-xs ">
              Select VISA PROVIDER
            </label>

            <select
              name="company"
              id={`addOrEdit-company`}
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              value={company}
              onChange={(e) => {
                const errorElem =
                  document.getElementById(`quotation-company_id`);
                errorElem.style.display = "none";
                setCompany(e.target.value);
              }}
            >
              {loadedValues?.company_id ? (
                <option value="" hidden disabled>
                  SELECT VISA PROVIDER
                </option>
              ) : (
                <option value="" hidden disabled>
                  SELECT VISA PROVIDER
                </option>
              )}
              {companyOptions.map((com) => (
                <option key={com.id} value={com.id} id={`company-${com.id}`}>
                  {com.name}
                </option>
              ))}
            </select>
            <p
              id={`quotation-company_id`}
              className="hidden w-full h-5 bg-red/5 text-red text-xs"
            ></p>
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-`} className="text-xs ">
              SELECT SOURCE
            </label>

            <select
              name="source"
              id={`addOrEdit-source`}
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              value={source}
              onChange={(e) => {
                const errorElem =
                  document.getElementById(`quotation-source_id`);
                errorElem.style.display = "none";
                setSource(e.target.value);
              }}
            >
              {loadedValues?.source_id ? (
                <option value="" hidden disabled>
                  Select a Source
                </option>
              ) : (
                <option value="" hidden disabled>
                  Select a Source
                </option>
              )}
              {sourceOptions.map((sou) => (
                <option key={sou.id} value={sou.id} id={`source-${sou.id}`}>
                  {sou.name}
                </option>
              ))}
            </select>
            <p
              id={`quotation-source_id`}
              className="hidden w-full h-5 bg-red/5 text-red text-xs"
            ></p>
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-`} className="text-xs ">
              Select Sector
            </label>

            <select
              name="sector"
              id={`addOrEdit-sector`}
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              value={sector}
              onChange={(e) => {
                const errorElem =
                  document.getElementById(`quotation-sector_id`);
                errorElem.style.display = "none";
                setSector(e.target.value);
              }}
            >
              {loadedValues?.sector_id ? (
                <option value="" hidden disabled>
                  Select a Sector
                </option>
              ) : (
                <option value="" hidden disabled>
                  Select a Sector
                </option>
              )}
              {sectorOptions.map((sec) => (
                <option key={sec.id} value={sec.id} id={`sector-${sec.id}`}>
                  {sec.name}
                </option>
              ))}
            </select>
            <p
              id={`quotation-sector_id`}
              className="hidden w-full h-5 bg-red/5 text-red text-xs"
            ></p>
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-quotType`} className="text-xs ">
              Select Quotation Type
            </label>

            <select
              name="quotType"
              id={`addOrEdit-quotType`}
              required
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              value={quotType}
              onChange={(e) => {
                const errorElem = document.getElementById(
                  `quotation-quotation_type_id`
                );
                errorElem.style.display = "none";
                setQuotType(e.target.value);
              }}
            >
              {loadedValues?.quotation_type_id ? (
                <option value="" hidden disabled>
                  Select Quotation Type
                </option>
              ) : (
                <option value="" hidden disabled>
                  Select Quotation Type
                </option>
              )}
              {quotationTypeOptions.map((cl) => (
                <option key={cl.id} value={cl.id} id={`quotType-${cl.id}`}>
                  {cl.name}
                </option>
              ))}
            </select>

            <p
              id={`quotation-quotation_type_id`}
              className="hidden w-full h-5 bg-red/5 text-red text-xs"
            ></p>
          </div>
          {quotType == 3 && (
            <div className="flex flex-col items-center max-w-md w-full mx-auto px-2">
              <label
                htmlFor={`addOrEdit-quotType`}
                className="text-xs text-left mt-2 w-full"
              >
                Select Hour Type
              </label>

              <select
                name="hourType"
                id={`addOrEdit-hourType`}
                required
                className="border-[1px] max-w-md  w-full mb-2 border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                value={hourType}
                onChange={(e) => {
                  setHourType(e.target.value);
                }}
              >
                <option value="">Select Hour Type</option>
                <option value={8}>8 Hour</option>
                <option value={9}>9 Hour</option>
                <option value={10}>10 Hour</option>
                <option value={11}>11 Hour</option>
                <option value={12}>12 Hour</option>
              </select>
            </div>
          )}
          {editing && (
            <div className="flex flex-col p-2 gap-1 w-full max-w-md">
              <label htmlFor={`addOrEdit-quotType`} className="text-xs ">
                Select Status
              </label>
              <select
                name="quotType"
                id={`addOrEdit-quotType`}
                required
                className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                value={status}
                onChange={(e) => {
                  const errorElem = document.getElementById(`quotation-status`);
                  errorElem.style.display = "none";
                  setStatus(e.target.value);
                }}
              >
                <option value="" hidden disabled>
                  Select Status
                </option>
                {statusOptions.map((cl) => (
                  <option key={cl.id} value={cl.name} id={`quotType-${cl.id}`}>
                    {cl.name}
                  </option>
                ))}
              </select>
              {status === "Rejected" && (
                <textarea
                  name="rejected_reason"
                  required
                  spellCheck={false}
                  // value={rejectedReason}
                  defaultValue={loadedValues.rejected_reason}
                  onChange={(e) =>
                    setRejectedReason(e.target.value?.toUpperCase())
                  }
                  className="textarea textarea-bordered textarea-xs w-full  mt-2"
                  placeholder="Reason"
                />
              )}

              {/* xs */}

              <p
                id={`quotation-status`}
                className="hidden w-full h-5 bg-red/5 text-red text-xs"
              ></p>
            </div>
          )}
          {/* {editing && status === "Approved" && (
            <div className="flex flex-col p-2 gap-1 w-full max-w-md">
              <label htmlFor={`addOrEdit-date`} className="text-xs ">
                Approved Date
              </label>
              <input
                type="date"
                name="date"
                id={`addOrEdit-date`}
                // required
                className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                value={date.original}
                onChange={(e) => {
                  const errorElem = document.getElementById(
                    `quotation-approved_date`
                  );
                  errorElem.style.display = "none";
                  const ddmmyyyy = new Date(e.target.value)
                    .toJSON()
                    .slice(0, 10)
                    .split("-")
                    .reverse()
                    .join("-");
                  setDate({ transformed: ddmmyyyy, original: e.target.value });
                }}
              />
              <p
                id={`quotation-approved_date`}
                className="hidden w-full h-5 bg-red/5 text-red text-xs"
              ></p>
            </div>
          )}
          {editing && status === "Rejected" && (
            <div className="flex flex-col p-2 gap-1 w-full max-w-md">
              <label htmlFor={`addOrEdit-date`} className="text-xs ">
                Rejected Date
              </label>
              <input
                type="date"
                name="date"
                id={`addOrEdit-date`}
                required
                className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                value={rejectedDate.original}
                onChange={(e) => {
                  const errorElem = document.getElementById(
                    `quotation-rejected_date`
                  );
                  errorElem.style.display = "none";
                  const ddmmyyyy = new Date(e.target.value)
                    .toJSON()
                    .slice(0, 10)
                    .split("-")
                    .reverse()
                    .join("-");
                  setRejectedDate({
                    transformed: ddmmyyyy,
                    original: e.target.value,
                  });
                }}
              />
              <p
                id={`quotation-rejected_date`}
                className="hidden w-full h-5 bg-red/5 text-red text-xs"
              ></p>
            </div>
          )} */}

          <div className="p-2  w-full max-w-md flex gap-3">
            <button
              className="w-full ring-1 rounded-md text-xs ring-black"
              onClick={() => cancelForm()}
            >
              Cancel
            </button>
            <button
              className="bg-black dark:bg-red w-full text-xs text-white rounded-md py-2 flex justify-center items-center gap-2"
              type="submit"
              disabled={submitFormLoading}
            >
              <p>Submit</p>
              {submitFormLoading ? (
                <CgSpinner className="animate-spin" />
              ) : (
                <HiArrowLongRight size={"1.2rem"} />
              )}
            </button>
          </div>
        </form>
      ) : (
        <LoadingWithLable />
      )}
    </div>
  );
}
